import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslationService } from "@services/translation.service";
import "./v-tags.component.scss";

export interface IVeriTag<T> {
    id?: number;
    label: string;
    data?: T;

    show?: boolean;
    showRemove?: boolean;
    accentColor?: string;
    clickCallback?: () => void;
}

@Component({
    selector: "v-tags",
    template: require("./v-tags.component.html")
})
export class VTagsComponent implements OnInit {

    @Input() tags: IVeriTag<any>[] = [];
    @Input() showAdd: boolean = false;
    @Input() showRemove: boolean = true;
    @Input() fillVoid: boolean = false;
    @Input() voidLabel: string = this.translationService.t('vTags.noTags');
    @Input() max: number = -1;
    @Input() large: boolean = false;;

    @Output() onClickRemoveTag = new EventEmitter<IVeriTag<any>>();

    filteredTags: IVeriTag<any>[] = [];

    constructor(private translationService: TranslationService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(): void {
        this.draw();
    }

    click(tag: any): void {
        // TODO
        if (tag?.clickCallback) {
            tag.clickCallback();
        }
    }

    remove(tag: IVeriTag<any>): void {
        if (!tag) {
            return;
        }

        this.onClickRemoveTag.emit(tag);
    }

    // ---

    private draw(): void {
        if (this.showAdd) {
            const addTag = {
                id: -1,
                show: this.showAdd,
                label: ``,
                icon: `add_box`,
                clickCallback: null
            };

            if (this.tags.length == 0) {
                this.tags.push(addTag);
            }
        }

        this.filterTag();
        this.addVoidElement();
    }

    private filterTag(): void {
        this.filteredTags = this.tags?.filter((tags, index) => this.max === -1 || (index + 1) <= this.max);

        if (this.fillVoid) {

        }
    }

    private addVoidElement(): void {
        if (!this.fillVoid || this.tags?.length > 0) {
            return;
        }

        this.tags.push({
            id: -2,
            show: true,
            label: this.voidLabel,
        });
    }
}
